import type { User } from '../firebase/firebase';
import {
	defaultCloudFunctionServices,
	makeCloudFunctionRequestReturnSuccessStatus,
} from './BaseCloudFunctionRequests';
import { HTTPSCloudFunctionURLs } from './HTTPSCloudFunctionURLs';

export type DeleteNoteBody = {
	leaveID: string;
	noteID: string;
};

export const deleteLeaveNote = async (
	abortSignal: AbortSignal,
	user: User,
	leaveID: string,
	noteID: string,
): Promise<void> => {
	await makeCloudFunctionRequestReturnSuccessStatus<DeleteNoteBody>({
		abortSignal,
		user,
		url: HTTPSCloudFunctionURLs.DeleteLeaveNote,
		method: 'POST',
		services: defaultCloudFunctionServices,
		body: {
			leaveID,
			noteID,
		},
	});
};
